import { useEffect, useState } from "react";
import { AutoComplete } from "../AutoComplete";
import { useUtility } from "../../contexts/auth/UtilityContext";
import { ItemPair } from "../../firestore/Types/UI/ItemPair";
import { getSchoolImageURL } from "../../firebase/storage/SchoolFunction";
import { SchoolView } from "../../firestore/Types/SchoolSchema";
import { SchoolTag } from "../SchoolTag";
import { AccountView } from "../../firestore/Types/AccountSchema";
import { updateAccountSchoolID } from "../../firestore/Functions/accountFunctions";

export function School({ account, refreshAccount}: { account: AccountView, refreshAccount: () => Promise<void> }) {
    const [school, setSchool] = useState<SchoolView>();
    const [SchoolId, setSchoolId] = useState("");
    const [imageUrl, setImageUrl] = useState("");
    const [isSaving, setIsSaving] = useState(false);
    const [isEdited, setIsEdited] = useState(false);
    const { schools } = useUtility();

    useEffect(() => {
        if (account.SchoolID !== SchoolId) {
            setIsEdited(true);
        }
    }, [SchoolId, account]);

    useEffect(() => {
        if (account.SchoolID) {
            setSchoolId(account.SchoolID);
        }
    }, [account]);

    useEffect(() => {
        for (let i = 0; i < schools.length; i++) {
            if (schools[i].Id === SchoolId) {
                setSchool(schools[i]);
            }
        }
    }, [SchoolId, schools]);

    useEffect(() => {
        if (SchoolId === "") {
            return;
        }
        getSchoolImageURL(SchoolId).then((url) => {
            setImageUrl(url);
        });
    }, [SchoolId]);

    const handleSave = async () => {
        setIsSaving(true);
        await updateAccountSchoolID(SchoolId);
        await refreshAccount();
        setIsSaving(false);
        setIsEdited(false);
    }

    if (schools.find(school => school.Id === account.SchoolID)) {
        return (
            <>
                <SchoolTag school={school!} imageUrl={imageUrl} />
            </>
        );
    }
    
    return (
        <>
            {schools.find(school => school.Id === account.SchoolID) ? 
            <SchoolTag school={school!} imageUrl={imageUrl} /> : 
            <>
                <div className="flex flex-row">
                        <div className="basic-form-label">School</div>
                </div>
                <AutoComplete Items={schools.map((school) => ({ Text: school.Name, Value: school.Id} as ItemPair))} setValue={setSchoolId}/>
                    <SchoolTag />
                    {isEdited && <div className="flex flex-row-reverse pt-2"><button className="primary-button" onClick={handleSave}>Save</button></div>}
                {isSaving && <div>Saving...</div> }
            </>
            }
        </>
    );
}